<section>
    <div class="cw">

        <button class="darkButton" (click)="onDelete()">dialog</button>

        <div fxLayoutAlign=" center">
            <img [src]="empresa.foto" alt="foto de perfil" class="avatar4">
            <div class="mgl10">
                <h6 class="ft500 mgb0 mgt0">{{empresa.nombre}}</h6>
                <p class="mgb0 mgt0">Empresa cliente ID: {{empresa.id}}</p>
            </div>
        </div>
        

        <div fxLayout="row" fxLayoutAlign="space-between" class="mgt50 mgb10">
            <div>
                <h6 class="ft500 ft16"> Usuarios</h6>
            </div>
            <div *ngIf="agregarUsuario===0" (click)="agregarUsuario=1" fxLayout="row" fxLayoutAlign=" center"
                class="blueLink">
                <span class="blueLink ft500"> Agregar usuario</span>
                <mat-icon class="mgl05 linkIcon ft22">add</mat-icon>
            </div>
        </div>

        <!-- registrar nuevo usuario de empresa -->
        <div *ngIf="agregarUsuario===1">
            <div fxLayout="row" fxLayoutAlign="center end">
                <div fxLayout="column" class="fw mgb10">
                    <label for="">Nombres y apellidos</label>
                    <input type="nombre" class="fw" #userName required>
                </div>

                <div fxLayout="column" class="fw mgl10 mgb10">
                    <label for="">Correo electrónico</label>
                    <input type="email" class="fw" #userEmail required>
                </div>

                <div fxLayout="column" class="fw mgl10 mgb10">
                    <label for="">Contraseña</label>
                    <input type="password" class="fw" #userPwd required>
                </div>

                <div fxLayout="column" class="mgl10 mgb10">
                    <button class="darkButton"
                        (click)="authService.SignUpUsuarioEmpresa(userEmail.value, userPwd.value, userName.value, empresa.nombre,empresa.id)">
                        Registrar usuario
                    </button>
                </div>
            </div>
            <div class="mgb20">
                <a class="blueLink" (click)="agregarUsuario=0">Cancelar</a>
            </div>
        </div>



        <div class="pd0 border radius3 backWhite w-100">
            <table style="width:100%">
                <tr>
                    <th class="w-10">Usuario</th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Contrseña</th>
                </tr>
                <tr *ngFor="let item of usuariosEmpresa;  let i=index">
                    <td class="centertext w-10"> {{i}} </td>
                    <td class="centertext">
                        <a class="blueLink">{{item.nombreCompleto}}</a>
                    </td>
                    <td> {{item.email}}</td>
                    <td> pasdasd</td>
                </tr>
            </table>
        </div>

        <!-- Agregar usuarios a curso -->

        <!-- {{listaCursos[0].titulo}} -->
        <div *ngFor="let item of listaCursos;  let i=index">
            {{item.titulo}}
        </div>

        <h6 class="h6Title"> Inscribir usuarios en nuevo curso</h6>
        <select [(ngModel)]="cursoId" [ngModelOptions]="{standalone: true}" class="fw" (change)="cargarCursos()">
            <option *ngFor="let item of listaCursos;  let i=index" [ngValue]="item.id">
                {{item.titulo}}
            </option>
        </select>


        <div class="mgt20 pd0 border radius3 backWhite w-100">
            <table style="width:100%">
                <tr>
                    <th class="w-10">Usuario</th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Asignar</th>
                </tr>
                <tr *ngFor="let item of usuariosEmpresa;  let i=index">
                    <td class="centertext w-10"> {{i}} </td>
                    <td class="centertext">
                        <a class="blueLink">{{item.nombreCompleto}}</a>
                    </td>
                    <td> {{item.email}}</td>
                    <td class="centertext w-10">
                        <input type="checkbox"  (change)="asignarCursoUsuarios(item.email)" [checked]>
                    </td>
                </tr>
            </table>
        </div>
        {{inscribirUsuarios}}

        <!-- Cursos y usuarios existentes -->
        <h6 class="h6Title"> Cursos y usuarios existentes</h6>

        <div class="pd0 border radius3 backWhite w-100">
            <table style="width:100%">
                <tr>
                    <th>Num.</th>
                    <th>Curso</th>
                    <th>Nombre</th>
                </tr>
                <tr *ngFor="let item of [1,2,3,4];  let i=index">
                    <td class="centertext w-20"> {{i}} </td>
                    <td> Mantenimiento centrado en confiabilidad</td>
                    <td class="centertext">
                        <div fxLayout="row" fxLayoutAlign="center center" class="fw">
                            <span>Andres Gonzalez Giraldo</span>
                            <mat-icon class="mgl10 linkIcon light-icon-colorf ft18 cursorPointer">delete_outline
                            </mat-icon>
                        </div>
                    </td>
                </tr>
            </table>

        </div>
    </div>
</section>